import { ApiFactory, initBfApi } from '~library/services'
import { initAuthApi, initUnAuthApi, initBindApi } from './apis'
import axiosAuthInstance from './axios-auth-instance'
import axiosBindInstance from './axios-bind-instance'
import axiosUnAuthInstance from './axios-un-auth-instance'

export type Api = typeof api

export const api = {
  ...initUnAuthApi(new ApiFactory(axiosUnAuthInstance)),
  ...initAuthApi(new ApiFactory(axiosAuthInstance)),
  ...initBindApi(new ApiFactory(axiosBindInstance)),
  ...initBfApi({
    authApi: new ApiFactory(axiosAuthInstance),
    unAuthApi: new ApiFactory(axiosUnAuthInstance)
  })
}
